import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { AuthService } from '../auth';
import { passwordMatchValidator } from '../shared/validators';

import { SEND_CODE_ATTEMPT_COUNTDOWN_FROM } from './constants';
import { FormDataType } from './types';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent {
  /** Текущее значение обратного отсчета */
  countdownValue = 0;

  /** Флаг, что всплывающая подсказка видна */
  codeHintVisible = false;

  /** Флаг, что обратный отсчет начался */
  isCountdownStarted = false;

  private countdown$?: Subscription;

  passwordHide = true;

  codeFieldVisible = false;
  private shortCode?: number;

  form = new FormGroup(
    {
      numberLS: new FormControl(undefined, [Validators.required]),
      email: new FormControl(undefined, [Validators.required, Validators.email]),
      phone: new FormControl(undefined, [Validators.required, Validators.pattern('^\\+7\\d{10}$')]),
      password: new FormControl(undefined, [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'),
      ]),
      confirmPassword: new FormControl(undefined, [Validators.required]),
      code: new FormControl(undefined, [Validators.required]),
    },
    { validators: [passwordMatchValidator] },
  );

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  get numberLSControl() {
    return this.form.get('numberLS');
  }

  get numberLSValue() {
    return this.numberLSControl.value;
  }

  get emailControl() {
    return this.form.get('email');
  }

  get emailValue() {
    return this.emailControl.value;
  }

  get phoneControl() {
    return this.form.get('phone');
  }

  get phoneValue() {
    return this.phoneControl.value;
  }

  get passwordControl() {
    return this.form.get('password');
  }

  get passwordValue() {
    return this.passwordControl.value;
  }

  get confirmPasswordControl() {
    return this.form.get('confirmPassword');
  }

  get confirmPasswordValue() {
    return this.confirmPasswordControl.value;
  }

  get codeControl() {
    return this.form.get('code');
  }

  get codeValue() {
    return this.codeControl.value;
  }

  getCode() {
    const { phone, numberLS } = this.form.getRawValue() as FormDataType;
    this.codeFieldVisible = true;
    this.countdown();

    this.authService.getCode(phone, numberLS).subscribe(res => {
      this.shortCode = res.shortCode;
    });
  }

  onClickRegistrationButton() {
    const { numberLS, email, phone, password, code } = this.form.value as FormDataType;
    this.authService
      .registration({
        koD_LSCH: numberLS,
        email,
        phone,
        password,
        code,
        shortCode: this.shortCode,
      })
      .subscribe(() => {
        this.router.navigateByUrl('/');
      });
  }

  private resetCountdown(): void {
    if (this.countdown$) {
      this.countdown$.unsubscribe();
    }
  }

  /**
   * Таймер обратного отсчета, когда можно будет отправить код повторно
   * */
  private countdown(): void {
    this.resetCountdown();
    this.countdownValue = SEND_CODE_ATTEMPT_COUNTDOWN_FROM;
    this.isCountdownStarted = true;

    this.countdown$ = interval(1000)
      .pipe(take(SEND_CODE_ATTEMPT_COUNTDOWN_FROM))
      .subscribe({
        next: () => {
          this.countdownValue -= 1;
        },
        complete: () => {
          this.isCountdownStarted = false;
        },
      });
  }
}
